import isEmpty from "lodash-es/isEmpty";
import { EfsMelcoEfsModelsMappingFileAttribute } from "melco-shared-logic";
import { useDataAssignments } from "../../hooks/inputFormats/useDataAssignments";
import { DisplayDataSource } from "./DisplayDataSource";

type DisplayFilenameRuleValueProps = {
  filenameRule: EfsMelcoEfsModelsMappingFileAttribute;
};

export const DisplayFilenameRuleValue: React.FC<
  DisplayFilenameRuleValueProps
> = ({ filenameRule }) => {
  const dataAssignments = useDataAssignments();

  const { value, format_detail_id: dataSourceId } = filenameRule;

  if (!isEmpty(dataSourceId)) {
    return (
      <DisplayDataSource
        dataSourceId={dataSourceId!}
        dataAssignments={dataAssignments}
      />
    );
  }

  return <span>{value}</span> ?? null;
};
